import React, { useCallback } from "react";
import Joins from "../components/Join";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import {
  jssPreset,
  StylesProvider,
  makeStyles,
} from "@material-ui/core/styles";
import { create } from "jss";
import jssTemplate from "jss-plugin-template";

import { useSelector, useDispatch } from "react-redux";


import {
  changeGender,
  changeName,
  changeBirthday,
  changeLunar,
  changePhone,
  changeResidence,
  changePersonal,
  changeMarketing,
  changeThirdParty,
  changeSmsYn,
  changeKakaoYn,
  changeAdYn,
  changeRecommend,
  changePartDiv,
  changePartNo,
  changeTotalAllYn,
  changeAllYn,
  changeMemberShip,
  changeDangunMarketAd,
  changeBorderAd,
  changeJiinSoge,
  changeMoonja,
  changeBtv,
  changeEmart,
  changeEtc,
  changeEtcDetail,
  changeJoinGb,
  chanTeleCompany,
  changeCertificationID,
  changeInOutGb,
  incrementCertifistep,
  changePhoneValid,
  changeCertiInput,
  changeSelfCertification,
  changeJeonMoonAll,
  changeJeonMoon1,
  changeJeonMoon2,
  changeJeonMoon3,
  changeJeonMoon4,

} from "../modules/join";

const useStyles = makeStyles({
  joinRoot: ` height:75vh;
          margin:0 auto;
  `,
  joinRootBox: `
  overflow:auto;
  max-width:800px;
  height:70vh;
  margin:0 auto;
  padding-left : 15px;
  padding-right : 15px;
  padding-bottom:10px;
  font-size:14px;
  color:#000;
  background:#fff;
  -webkit-box-sizing:border-box;
  box-sizing:border-box;
  overflow-y:auto;
  `,

  "@media screen and (min-width:600px)": {
    joinRoot: ` height:69vh;
  `,
    joinRootBox: `max-width:520px;
    margin:0 auto;
    height:68vh;
    padding-left : 50px;
    padding-right : 50px;
    padding-top:20px;
    padding-bottom:20px;
    border-radius:2px;
    overflow-y:auto;`,
  },
});

function Child(props) {
  const classes = useStyles();
  const Join = useSelector((state) => state.join);
  //console.log(Join);

  const dispatch = useDispatch();

  const onChangeJoinGb = useCallback((JoinGb) => dispatch(changeJoinGb(JoinGb)), [
    dispatch,
  ]);
  const onChangeDangunMarketAd = useCallback((dangunMarketAd) => dispatch(changeDangunMarketAd(dangunMarketAd)), [
    dispatch,
  ]);
  const onChangeBorderAd = useCallback((BorderAd) => dispatch(changeBorderAd(BorderAd)), [
    dispatch,
  ]);
  const onChangeJiinSoge = useCallback((JiinSoge) => dispatch(changeJiinSoge(JiinSoge)), [
    dispatch,
  ]);
  const onChangeMoonja = useCallback((Moonja) => dispatch(changeMoonja(Moonja)), [
    dispatch,
  ]);
  const onChangeEtc = useCallback((Etc) => dispatch(changeEtc(Etc)), [
    dispatch,
  ]);
  const onChangeEtcDetail = useCallback((EtcDetail ) => dispatch(changeEtcDetail(EtcDetail )), [
    dispatch,
  ]);
  const onChangeBtv = useCallback((btv) => dispatch(changeBtv(btv)), [
    dispatch,
  ]);
  const onChangeEmart = useCallback((emart) => dispatch(changeEmart(emart)), [
    dispatch,
  ]);

  const onChangeName = useCallback((name) => dispatch(changeName(name)), [
    dispatch,
  ]);

  const onChangeBirthday = useCallback(
    (birthday) => dispatch(changeBirthday(birthday)),
    [dispatch]
  );
  const onChangeLunar = useCallback((lunar) => dispatch(changeLunar(lunar)), [
    dispatch,
  ]);
  const onChangePhone = useCallback((phone) => dispatch(changePhone(phone)), [
    dispatch,
  ]);
  const onChangeGender = useCallback(
    (gender) => dispatch(changeGender(gender)),
    [dispatch]
  );
  const onChangeResidence = useCallback(
    (residence) => dispatch(changeResidence(residence)),
    [dispatch]
  );
  const onChangeRecommend = useCallback(
    (recommend) => dispatch(changeRecommend(recommend)),
    [dispatch]
  );
  const onChangeMemberShip = useCallback(
    (memberShip) => dispatch(changeMemberShip(memberShip)),
    [dispatch]
  );
  const onChangePersonal = useCallback(
    (personal) => dispatch(changePersonal(personal)),
    [dispatch]
  );
  const onChangeMarketing = useCallback(
    (marketing) => dispatch(changeMarketing(marketing)),
    [dispatch]
  );
  const onChangeThirdParty = useCallback(
    (thirdParty) => dispatch(changeThirdParty(thirdParty)),
    [dispatch]
  );
  const onChangeSmsYn = useCallback(
    (thirdParty) => dispatch(changeSmsYn(thirdParty)),
    [dispatch]
  );
  const onChangeKakaoYn = useCallback(
    (thirdParty) => dispatch(changeKakaoYn(thirdParty)),
    [dispatch]
  );
  const onChangeAdYn = useCallback(
    (thirdParty) => dispatch(changeAdYn(thirdParty)),
    [dispatch]
  );
  const onChangePartDiv = useCallback(
    (partDiv) => dispatch(changePartDiv(partDiv)),
    [dispatch]
  );
  const onChangePartNo = useCallback(
    (partNo) => dispatch(changePartNo(partNo)),
    [dispatch]
  );
  const onChangeAllYn = useCallback((allYn) => dispatch(changeAllYn(allYn)), [
    dispatch,
  ]);
  const onChangeTotalAllYn = useCallback(
    (totalAllYn) => dispatch(changeTotalAllYn(totalAllYn)),
    [dispatch]
  );

  const onChangeCertificationID  = useCallback((id) => dispatch(changeCertificationID(id)), [
    dispatch,
  ]);
  const onChangeInOutGb  = useCallback((gb) => dispatch(changeInOutGb(gb)), [
    dispatch,
  ]);

  const onChanTeleCompany   = useCallback((gb) => dispatch(chanTeleCompany(gb)), [
    dispatch,
  ]);

  const onIncrementCertifistep   = useCallback(() => dispatch(incrementCertifistep()), [
    dispatch,
  ]);

  const onChangePhoneValid   = useCallback((valid) => dispatch(changePhoneValid(valid)), [
    dispatch,
  ]);

  const onChangeCertiInput  = useCallback((id) => dispatch(changeCertiInput(id)), [
    dispatch,
  ]);
   
  const onChangeSelfCertification  = useCallback((valid) => dispatch(changeSelfCertification(valid)), [
    dispatch,
  ]);


  const onChangeJeonMoonAllYn = useCallback((allYn) => dispatch(changeJeonMoonAll(allYn)), [
    dispatch,
  ]);

  const onChangeJeonMoon1Yn = useCallback((Yn) => dispatch(changeJeonMoon1(Yn)), [
    dispatch,
  ]);

  const onChangeJeonMoon2Yn = useCallback((Yn) => dispatch(changeJeonMoon2(Yn)), [
    dispatch,
  ]);

  const onChangeJeonMoon3Yn = useCallback((Yn) => dispatch(changeJeonMoon3(Yn)), [
    dispatch,
  ]);

  const onChangeJeonMoon4Yn = useCallback((Yn) => dispatch(changeJeonMoon4(Yn)), [
    dispatch,
  ]);



  return (
    <div className={classes.joinRoot}>
      <div className={classes.joinRootBox}>
        <Joins
          Join={Join}
          onChangeJeonMoonAllYn={onChangeJeonMoonAllYn}
          onChangeJeonMoon1Yn={onChangeJeonMoon1Yn}
          onChangeJeonMoon2Yn={onChangeJeonMoon2Yn}
          onChangeJeonMoon3Yn={onChangeJeonMoon3Yn}
          onChangeJeonMoon4Yn={onChangeJeonMoon4Yn}
          onChangePhoneValid ={onChangePhoneValid}
          onChangeCertificationID={onChangeCertificationID}
          onChangeInOutGb={onChangeInOutGb}
          onChanTeleCompany={onChanTeleCompany}
          onIncrementCertifistep={onIncrementCertifistep}
          onChangeName={onChangeName}
          onChangeBirthday={onChangeBirthday}
          onChangeLunar={onChangeLunar}
          onChangePhone={onChangePhone}
          onChangeGender={onChangeGender}
          onChangeResidence={onChangeResidence}
          onChangeRecommend={onChangeRecommend}
          onChangeMemberShip={onChangeMemberShip}
          onChangePersonal={onChangePersonal}
          onChangeMarketing={onChangeMarketing}
          onChangeThirdParty={onChangeThirdParty}
          onChangeSmsYn={onChangeSmsYn}
          onChangeKakaoYn={onChangeKakaoYn}
          onChangeAdYn={onChangeAdYn}
          partCode={props.match.params.partcode}
          onChangePartDiv={onChangePartDiv}
          onChangePartNo={onChangePartNo}
          onChangeAllYn={onChangeAllYn}
          onChangeTotalAllYn={onChangeTotalAllYn}
          onChangeDangunMarketAd={onChangeDangunMarketAd}
          onChangeBorderAd={onChangeBorderAd}
          onChangeJiinSoge={onChangeJiinSoge}
          onChangeMoonja={onChangeMoonja}
          onChangeEtc={onChangeEtc}
          onChangeEtcDetail={onChangeEtcDetail}
          onChangeJoinGb={onChangeJoinGb}
          onChangeBtv={onChangeBtv}
          onChangeEmart={onChangeEmart}
          onChangeCertiInput={onChangeCertiInput}
          onChangeSelfCertification={onChangeSelfCertification}
        ></Joins>
      </div>
    </div>
  );
}


function JoinContainer({ match }) {
  const jss = create({
    plugins: [jssTemplate(), ...jssPreset().plugins],
  });

  return (
    <>
      <Header title="신원 특판 멤버십 가입 신청서" />
      <StylesProvider jss={jss}>
        <Child match={match} />
      </StylesProvider>
      <Footer />
    </>
  );
}

export default JoinContainer;
